module.exports = __webpack_public_path__ + "static/img/pin-multi-scheduled-irregular.43c7a54.svg";